import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { DialogData } from './popup.component';



@Injectable()
export class PopupService {
  showPopup$ = new BehaviorSubject<boolean>(false);
  data: DialogData;
  cancelCallback: Function;
  confirmCallback: Function;

  constructor() { }

  onCancel() {
    this.showPopup$.next(false);
    this.cancelCallback();
  }

  onConfirm() {
    this.showPopup$.next(false);
    this.confirmCallback();
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/popup/popup.service.ts